<script lang="ts" setup>
import {
  computed,
} from 'vue';
import { useUniqueId } from '../../../Composables/useUniqueId';
import { HelpText } from '@app/customer/Components/HelpText';

const props = defineProps<{
  modelValue?: string | null;
  value: string;
  name?: string | null;
  id?: string | null;
  label: string;
  imageUrl?: string | null;
  helpText?: string | null;
  disabled?: boolean;
  suffixType?: string | null;
  suffixContent?: string | null;
}>();

const emit = defineEmits(['update:modelValue']);

const elementId = computed((): string => props.id || useUniqueId('searchField'));

const checked = computed((): boolean => {
  return props.modelValue === props.value;
});

const onChange = (): void => {
  if (!props.disabled) {
    emit('update:modelValue', props.value);
  }
};
</script>

<template>
  <div
    class="w-full cursor-pointer flex items-center text-sm"
    @click="onChange"
  >
    <label
      class="flex items-center min-h-9 space-x-2 border border-slate-300 rounded-md w-full py-1 px-3 cursor-pointer text-sm text-slate-700 tracking-normal"
      :label="label"
      :for="elementId"
    >
      <input
        :id="elementId"
        type="radio"
        :name="name"
        :value="value"
        :checked="checked"
        :disabled="disabled"
        class="cursor-pointer accent-blue-500 focus:outline-none"
      >

      <div class="flex flex-wrap items-center justify-between w-full gap-1">
        <span class="grow text-nowrap">{{ label }}</span>

        <span
          v-if="suffixType === 'text' && !! suffixContent"
          class="text-right text-xs text-slate-500"
        >
          {{ suffixContent }}
        </span>
        <span
          v-if="suffixType === 'badge' && !! suffixContent"
          class="rounded-md px-2 py-1 bg-green-200 text-xs text-green-900"
        >
          {{ suffixContent }}
        </span>
      </div>
    </label>

    <HelpText
      v-if="helpText"
      flush
    >
      {{ helpText }}
    </HelpText>
  </div>
</template>
